var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFallbackAvatar = function SvgFallbackAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "fallback-avatar_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".fallback-avatar_svg__st1{fill:{FILL_COLOR}}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 27c0 1.5-1 2-2.5 2h-13c-1.6 0-2.5-.5-2.5-2 0-4 4.5-7 9-7s9 3 9 7zM24 15c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4z",
    className: "fallback-avatar_svg__st1"
  })));
};
export default SvgFallbackAvatar;